const DATE_FMT = new Intl.DateTimeFormat(undefined, {
  year: "numeric",
  month: "short",
  day: "numeric"
});

const DATETIME_FMT = new Intl.DateTimeFormat(undefined, {
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit"
});

function parse(value: string | null | undefined): Date | null {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDate(value: string | null | undefined): string {
  const date = parse(value);
  return date ? DATE_FMT.format(date) : "—";
}

export function formatDateTime(value: string | null | undefined): string {
  const date = parse(value);
  return date ? DATETIME_FMT.format(date) : "—";
}

/** Whole days from now until `value` (negative if in the past). */
export function daysUntil(value: string | null | undefined): number | null {
  const date = parse(value);
  if (!date) return null;
  return Math.ceil((date.getTime() - Date.now()) / 86_400_000);
}

/** Renewal countdown for a non-negative day count: "Renews today", "Renews in 1 day", "Renews in 40 days". */
export function renewsIn(days: number): string {
  if (days <= 0) return "Renews today";
  return `Renews in ${days} ${days === 1 ? "day" : "days"}`;
}
